<div class="tn-topnav" *ngIf="!isLoginPage" >
    <nav id="nav">
        <div class="row" style="font-family: Roboto, sans-serif; margin-left: 100px;"> 
                <div class="logo-small tn-logo">
                    <a href="#" aria-label="www.tn.gov"></a>
                </div>
                <ul class="inline-list nav-items">
                    <a href="https://www.tn.gov/workforce/injuries-at-work/employers/employers/wc-exemption-registry.html" class="" aria-label="Home">
                        <li  class="home">
                            <mat-icon>home</mat-icon>
                        </li>
                    </a>
                    <a [routerLink]="'/search'">
                        <li class="searchText">
                            Search
                        </li>
                    </a>

                    <a href="https://www.tn.gov/workforce/injuries-at-work/employers/employers/wc-exemption-registry/exemption-registry-forms-and-faqs.html">
                        <li class="navListStyle">
                            Forms & FAQ
                        </li>
                    </a>
    
                </ul>
        </div>
    </nav>
</div>